import { SellerGroup, HistoryEntry } from './types';

export const mockSellerGroups: SellerGroup[] = [
  { id: 'GRP-001', name: 'Equipe Comercial SP', profile: 'Seller' },
  { id: 'GRP-002', name: 'Equipe Comercial RJ', profile: 'Seller' },
  { id: 'GRP-003', name: 'Gestao Nacional', profile: 'Industria' },
  { id: 'GRP-004', name: 'Diretoria Executiva', profile: 'Compra Agora' },
  { id: 'GRP-005', name: 'Supervisores Regionais', profile: 'Seller' },
  { id: 'GRP-006', name: 'Consultores Externos', profile: 'Industria' },
  { id: 'GRP-007', name: 'Equipe Comercial MG', profile: 'Seller' },
  { id: 'GRP-008', name: 'Analistas de Mercado', profile: 'Compra Agora' },
  { id: 'GRP-009', name: 'Coordenacao Sul', profile: 'Industria' },
  { id: 'GRP-010', name: 'Administracao Central', profile: 'Compra Agora' },
  { id: 'GRP-011', name: 'Equipe Comercial PR', profile: 'Seller' },
  { id: 'GRP-012', name: 'Equipe Comercial BA', profile: 'Seller' },
  { id: 'GRP-013', name: 'Supervisores Nordeste', profile: 'Industria' },
  { id: 'GRP-014', name: 'Consultores Internos', profile: 'Compra Agora' },
  { id: 'GRP-015', name: 'Coordenacao Norte', profile: 'Seller' },
];

export const mockHistory: HistoryEntry[] = [
  {
    id: 'HIST-001',
    date: '2026-02-27T14:30:00Z',
    user: 'Carlos Silva',
    changes: [
      { groupId: 'GRP-003', groupName: 'Gestao Nacional', oldProfile: 'Seller', newProfile: 'Industria' },
      { groupId: 'GRP-005', groupName: 'Supervisores Regionais', oldProfile: 'Compra Agora', newProfile: 'Seller' },
    ],
  },
  {
    id: 'HIST-002',
    date: '2026-02-26T10:15:00Z',
    user: 'Ana Oliveira',
    changes: [
      { groupId: 'GRP-010', groupName: 'Administracao Central', oldProfile: 'Industria', newProfile: 'Compra Agora' },
    ],
  },
  {
    id: 'HIST-003',
    date: '2026-02-25T16:45:00Z',
    user: 'Roberto Santos',
    changes: [
      { groupId: 'GRP-006', groupName: 'Consultores Externos', oldProfile: 'Seller', newProfile: 'Industria' },
      { groupId: 'GRP-008', groupName: 'Analistas de Mercado', oldProfile: 'Seller', newProfile: 'Compra Agora' },
      { groupId: 'GRP-009', groupName: 'Coordenacao Sul', oldProfile: 'Seller', newProfile: 'Industria' },
    ],
  },
  {
    id: 'HIST-004',
    date: '2026-02-24T09:00:00Z',
    user: 'Maria Costa',
    changes: [
      { groupId: 'GRP-004', groupName: 'Diretoria Executiva', oldProfile: 'Industria', newProfile: 'Compra Agora' },
    ],
  },
];
